import React from 'react';
import CrmTimelineListPage from './components/CrmTimelineListPage';

export default function TasksPage() {
  return (
    <CrmTimelineListPage
      pageKey="tasksPage"
      tasksOnly
    />
  );
}
